import { BCMSCurrency, BCMSDefaultModel, BCMSRecord, useBCMSModal, useModel, useWorkflowStep } from "@bcm-dev/bcms-vite";
import CustomSelect, { CustomSelectItem } from "compid/custom-ui/CustomSelect";
import ButtonContainer from "compid/shared/containers/ButtonContainer";
import PageLayoutContainer from "compid/shared/containers/PageLayoutContainer";
import CenterColumnContainer from "compid/shared/containers/PageLayoutContainer/containers/CenterColumnContainer";
import PageView from "compid/shared/containers/PageViewContainer";
import BillerView from "compid/shared/views/BillerView";
import BillerPaymentView from "compid/shared/views/BillerView/components/views/BillerPaymentView";
import UIButton from "compid/ui/UIButton";
import UITextInput from "compid/ui/UITextInput";
import { getAutopaySubmitMethod, getDefaultPayment, getSubmitMethod, getWorkflowSteps } from "compid/workflows/MakeAPayment";
import { Account, Autopay, Bill, Biller, Payment } from "model";

import "./styles.css";

export default function AddAddressForOvernightDeliveryPage(props) {
    const workflowStep = useWorkflowStep(getDefaultPayment, getWorkflowSteps);
    const { payments } = useModel();

    BCMSRecord.globalControllerFor([ Account, Biller, Bill, Payment, Autopay ], workflowStep.globalController);

    const info = workflowStep.read("info");
    const onUpdate = prop => value => workflowStep.update([ "info", prop ], value);

    const payment = workflowStep.read("payment");
    const bill = workflowStep.read("bill");

    const lastPayment = Payment.getLastPaymentByBillerID(bill.biller.id, payments);
    const billStatus = bill.status.toLowerCase();

    let status = bill.status === "paid" ? bill.payment.status : bill.status,
        dateLabel = bill.formatDate,
        amountLabel = bill.amount,
        showPaymentInfo = true,
        description = "";

    if (billStatus !== "due" && lastPayment) {
        description = <><span className="show-on-desktop">Last payment</span><span className="show-on-tablet">Last pmt</span></>;
        amountLabel = lastPayment.amount;
        status = lastPayment.status;
        dateLabel = lastPayment.formatDate;
    }
   
    showPaymentInfo = (billStatus !== "due" && !lastPayment) || billStatus === "canceled" ? false : showPaymentInfo;

    return (
        <PageView className="add-address-for-overnight-delivery-page">
            <p className="page-sub-header semi-bold-text">ADD ADDRESS FOR OVERNIGHT DELIVERY</p>

            <PageLayoutContainer>
                <div className="flex-container flex-vertical flex-width">
                    <div className="flex-height flex-container flex-vertical upper-content-container">
                        <BillerView
                            biller={ payment.to }
                            bill={ bill }
                            paymentInfo={
                                <BillerPaymentView description={ description } amount={ amountLabel } payment={ payment }
                                    status={ status } date={ dateLabel } biller={ payment.to } />
                            }
                            showPaymentInfo={ showPaymentInfo } />
                    </div>

                    <div className="flex-height flex-width flex-container all-center">
                        <CenterColumnContainer>
                            <div className="form-group flex-container flex-vertical">
                                <p className="top-text">To rush the delivery of your payment, we send a check through an overnight delivery service that requires a street address, not a P.O. box.</p>
                            
                                <div className="form-row flex-height street-address">
                                    <UITextInput placeHolder="Street address" value={ info.address } onChange={ onUpdate("address") } />
                                </div>

                                <div className="form-row flex-height">
                                    <UITextInput placeHolder="Address 2 (optional)" value={ info.addressTwo } onChange={ onUpdate("addressTwo") } />
                                </div>

                                <div className="form-row flex-height">
                                    <UITextInput placeHolder="City" value={ info.city } onChange={ onUpdate("city") } />
                                </div>

                                <div className="form-row flex-height custom-select-form-row">
                                    <CustomSelect label="State" helpText="Continental U.S. only" value={ info.state } onChange={ onUpdate("state") }>
                                        <CustomSelectItem value="AL">Alabama</CustomSelectItem>
                                        <CustomSelectItem value="AK">Alaska</CustomSelectItem>
                                        <CustomSelectItem value="AZ">Arizona</CustomSelectItem>
                                        <CustomSelectItem value="AR">Arkansas</CustomSelectItem>
                                        <CustomSelectItem value="CA">California</CustomSelectItem>
                                        <CustomSelectItem value="CO">Colorado</CustomSelectItem>
                                        <CustomSelectItem value="CT">Connecticut</CustomSelectItem>
                                        <CustomSelectItem value="DE">Delaware</CustomSelectItem>
                                        <CustomSelectItem value="DC">District Of Columbia</CustomSelectItem>
                                        <CustomSelectItem value="FL">Florida</CustomSelectItem>
                                        <CustomSelectItem value="GA">Georgia</CustomSelectItem>
                                        <CustomSelectItem value="HI">Hawaii</CustomSelectItem>
                                        <CustomSelectItem value="ID">Idaho</CustomSelectItem>
                                        <CustomSelectItem value="IL">Illinois</CustomSelectItem>
                                        <CustomSelectItem value="IN">Indiana</CustomSelectItem>
                                        <CustomSelectItem value="IA">Iowa</CustomSelectItem>
                                        <CustomSelectItem value="KS">Kansas</CustomSelectItem>
                                        <CustomSelectItem value="KY">Kentucky</CustomSelectItem>
                                        <CustomSelectItem value="LA">Louisiana</CustomSelectItem>
                                        <CustomSelectItem value="ME">Maine</CustomSelectItem>
                                        <CustomSelectItem value="MD">Maryland</CustomSelectItem>
                                        <CustomSelectItem value="MA">Massachusetts</CustomSelectItem>
                                        <CustomSelectItem value="MI">Michigan</CustomSelectItem>
                                        <CustomSelectItem value="MN">Minnesota</CustomSelectItem>
                                        <CustomSelectItem value="MS">Mississippi</CustomSelectItem>
                                        <CustomSelectItem value="MO">Missouri</CustomSelectItem>
                                        <CustomSelectItem value="MT">Montana</CustomSelectItem>
                                        <CustomSelectItem value="NE">Nebraska</CustomSelectItem>
                                        <CustomSelectItem value="NV">Nevada</CustomSelectItem>
                                        <CustomSelectItem value="NH">New Hampshire</CustomSelectItem>
                                        <CustomSelectItem value="NJ">New Jersey</CustomSelectItem>
                                        <CustomSelectItem value="NM">New Mexico</CustomSelectItem>
                                        <CustomSelectItem value="NY">New York</CustomSelectItem>
                                        <CustomSelectItem value="NC">North Carolina</CustomSelectItem>
                                        <CustomSelectItem value="ND">North Dakota</CustomSelectItem>
                                        <CustomSelectItem value="OH">Ohio</CustomSelectItem>
                                        <CustomSelectItem value="OK">Oklahoma</CustomSelectItem>
                                        <CustomSelectItem value="OR">Oregon</CustomSelectItem>
                                        <CustomSelectItem value="PA">Pennsylvania</CustomSelectItem>
                                        <CustomSelectItem value="RI">Rhode Island</CustomSelectItem>
                                        <CustomSelectItem value="SC">South Carolina</CustomSelectItem>
                                        <CustomSelectItem value="SD">South Dakota</CustomSelectItem>
                                        <CustomSelectItem value="TN">Tennessee</CustomSelectItem>
                                        <CustomSelectItem value="TX">Texas</CustomSelectItem>
                                        <CustomSelectItem value="UT">Utah</CustomSelectItem>
                                        <CustomSelectItem value="VT">Vermont</CustomSelectItem>
                                        <CustomSelectItem value="VA">Virginia</CustomSelectItem>
                                        <CustomSelectItem value="WA">Washington</CustomSelectItem>
                                        <CustomSelectItem value="WV">West Virginia</CustomSelectItem>
                                        <CustomSelectItem value="WI">Wisconsin</CustomSelectItem>
                                        <CustomSelectItem value="WY">Wyoming</CustomSelectItem>
                                    </CustomSelect>
                                </div>

                                <div className="form-row flex-height">
                                    <div className="flex-container flex-horizontal align-center">
                                        <UITextInput placeHolder="ZIP code (5-digit)" value={ info.zipFive } onChange={ onUpdate("zipFive") } maxLength={ 5 } />
                                        <UITextInput placeHolder="ZIP+4 (optional)" value={ info.zipFour } onChange={ onUpdate("zipFour") } maxLength={ 4 } />
                                    </div>
                                </div>

                                <PageButtonContainer payment={ payment } bill={ bill } workflowStep={ workflowStep } />
                            </div>
                        </CenterColumnContainer>
                    </div>
                </div>
            </PageLayoutContainer>
        </PageView>
    );
}

function PageButtonContainer(props) {
    const { open } = useBCMSModal();
    const { payment, workflowStep } = props ?? {};
    const { branding } = workflowStep.model ?? {};
    const { options } = branding ?? {};

    const isPaper = payment.to.paymentType === "paper";
    const isInstantPayment = payment.to.paymentType === "instantPayment";
    const isWithinMinutes = payment.to.paymentType === "withinMinutes";

    const hasRealTimeGoodFunds = Payment.hasRealTimeGoodFunds(payment.to.paymentType, branding);
    const feeIsSelected = Payment.getIfDateHasFee(payment.date, payment.to.paymentType, branding);
    const isRepeatPayment = workflowStep.read("repeatPayment") ?? false;

    const submitPayment = getSubmitMethod(workflowStep);
    const submitAutopay = getAutopaySubmitMethod(workflowStep);

    const getFee = () => {
        if (feeIsSelected) {
            let amount = isPaper
                ? BCMSCurrency.init(options.overnight_check_fee_rxp22 === "undefined" ? "14.95" : options.overnight_check_fee_rxp22).amount
                : BCMSCurrency.init(options.same_day_fee_rxp22 === "undefined" ? "9.95" : options.same_day_fee_rxp22).amount;

            if (isInstantPayment) { amount = BCMSCurrency.init(options.same_day_ip_fee_rxp22 === "Free" ? "0.00" : options.same_day_ip_fee_rxp22).amount; }
            if (isWithinMinutes) { amount = BCMSCurrency.init(options.within_minutes_ip_fee_rxp22 === "Free" ? "0.00" : options.within_minutes_ip_fee_rxp22).amount; }

            return amount;
        }

        return 0;
    }

    const totalAmount = BCMSCurrency.init(parseFloat(payment.amount.amount) + parseFloat(getFee())).format();
            
    const onCancel = evt => workflowStep.workflow.goStep(0);
    const onSubmit = evt => {
        const defaultPayment = BCMSDefaultModel.payment();
        const defaultPaymentAmount = parseFloat(defaultPayment.amount.amount);

        const payFromAccount = payment.from;
        const payFromAccountAccountBalance = parseFloat(payFromAccount.balance.amount);

        let paymentAmount = parseFloat(payment.amount.amount);
        paymentAmount = paymentAmount === 0 ? defaultPaymentAmount : paymentAmount;

        if (!isRepeatPayment) {
            if (hasRealTimeGoodFunds && paymentAmount > payFromAccountAccountBalance) {
                open("InsufficientFundsModal", { payAmount: payment.amount, payFrom: payFromAccount, onModalPayButtonClick: submitPayment });
            }

            submitPayment();
        }
        else { submitAutopay(); }
    }

    return (
        <ButtonContainer className="form-button-container">
            <UIButton className="secondary-button" onClick={ onCancel }>Cancel</UIButton>
            <UIButton className="primary-button" onClick={ onSubmit }>Pay { totalAmount }</UIButton>
        </ButtonContainer>
    );
}